  document.addEventListener('DOMContentLoaded', function() {
  // Referenz zum Head-Element und Dropdown
  const selectHead = document.querySelector('.select_item-head');
  const selectDropdown = document.querySelector('.select_item-dropdown');
  
  // Öffnen/Schließen des Dropdowns beim Klicken auf den Header
  selectHead.addEventListener('click', function(e) {
    selectDropdown.classList.toggle('active');
    e.stopPropagation();
  });
  
  // Bei Klick außerhalb des Dropdowns wird es geschlossen
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.select_item-motivcolor')) {
      selectDropdown.classList.remove('active');
    }
  });
  
  // Farbe im Header aktualisieren, wenn eine Farbe ausgewählt wird
  const colorInputs = document.querySelectorAll('.color-picker__input');
  const headColor = selectHead.querySelector('.color-picker__color');
  const headLabel = selectHead.querySelector('.color-picker__label');
  
  colorInputs.forEach(input => {
    input.addEventListener('change', function() {
      if (this.checked) {
        const colorName = this.value;
        const colorClass = `color-picker__color--${colorName}`;
        const colorLabel = this.nextElementSibling.nextElementSibling.textContent;
        
        // Alle Farbklassen vom Header-Element entfernen
        const classes = headColor.className.split(' ');
        classes.forEach(cls => {
          if (cls.startsWith('color-picker__color--') && cls !== 'color-picker__color') {
            headColor.classList.remove(cls);
          }
        });
        
        // Neue Farbklasse hinzufügen
        headColor.classList.add(colorClass);
        
        // Label aktualisieren
        headLabel.textContent = colorLabel;
        
        // Dropdown schließen nach Auswahl
        selectDropdown.classList.remove('active');
      }
    });
  });
  
  // Initialisierung: Die ausgewählte Farbe im Header anzeigen
  const checkedInput = document.querySelector('.color-picker__input:checked');
  if (checkedInput) {
    const colorName = checkedInput.value;
    const colorClass = `color-picker__color--${colorName}`;
    const colorLabel = checkedInput.nextElementSibling.nextElementSibling.textContent;
    
    headColor.classList.add(colorClass);
    headLabel.textContent = colorLabel;
  }
});